import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow, navigateToUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';

const LoaderPage = (props) => {

        const [seconds, setSeconds] = useState(props.routerInitializationTime);

         useEffect(() => {
             const interval = setInterval(() => {
                 setSeconds((prev) => {
                     if (prev <= 0) {
                         clearInterval(interval);
                         navigateToUrl(props.genericWizardAutomaticBlock);
                         return 0;
                     }
                     return prev - 1;
                 });
             }, 1000);

             return () => clearInterval(interval);
         }, [props.routerInitializationTime]);




         return (
           <div className='loader-page'>
             <div className='loader-img-wrapper'>
                <Image src={Config.epiBaseUrl + props.imageLoader} alt={'loading image'} />
             </div>
             <div>הנתב מבצע הפעלה מחדש כעת</div>
             <div className='router-time'>נותרו {seconds} שניות</div>
           </div>
         );

};

const mapStateToProps = (state) => {
  return {
    imageLoader: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.loadingPage.imageLoader,
    routerInitializationTime: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.loadingPage.routerInitializationTime,
    genericWizardAutomaticBlock: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.genericWizardAutomaticBlock,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoaderPage);
